export abstract class StateModel {
    protected constructor() {
    // All derived classes should be static
    }
}
